'use strict';

module.exports = {
  registerPathEventListeners: function () {
    this.on('add', this.onPathAdded.bind(this));
    this.on('mousedown', this.onPathLayerMousedown.bind(this));

    // Listen for resize marker drag start and end (for polygons)
    // @see https://github.com/Leaflet/Leaflet.draw/blob/master/src/edit/handler/Edit.SimpleShape.js#L109
    this.on('editstart', this.onPathLayerEditStart.bind(this));
    this.on('edit', this.onPathLayerEdit.bind(this));
  },

  onPathAdded: function () {
    this._drawInfoBox();
    this._updateMeasurements();
  },

  onPathLayerEdit: function () {
    this._drawInfoBox();
    this._updateMeasurements();
    // shape changed or moved... inform the store
    this.Actions.EditedActiveLayer.dispatch(this);

  },

  onPathLayerEditStart: function () {
    // Temporarily hide the popup while path is being dragged
    this.hidePopup();
  },

  onPathLayerMousedown: function (e) {
    var leafletLayer = e.target;
    var map = leafletLayer._map;

    // hack...
    // Gets around the L.Path._onMouseClick not triggering "_fireMouseEvent"
    //
    // we disable dragging on the map to ensure that the "_moved" flag is reset so
    // the layer is clickable and reenable map dragging as soon as the layer is clicked
    map.dragging.disable();
    this.once('click', function () {
      map.dragging.enable();
    });
  },

  _updateMeasurements: function () {
    // noop... child override
  },

  _drawInfoBox: function() {
    // override
  }

};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/mixins/PathEventMixin.js